import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const GetCategories=() => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.get(`/categories/`)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const AddCategory=({token,category}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/categories/add`,category)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteCategory=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/categories/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UpdateCategory=({token,category}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/categories/update/${category._id}`,category)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const ReOrderCategories=({token,list}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/categories/reorder/`,list)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


export {
    GetCategories,
    AddCategory,
    DeleteCategory,
    UpdateCategory,
    ReOrderCategories
}



